import PicklistMetadata from "../PicklistMetadata";

class ProjectPlanPhaseMilestoneReferenceTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseMilestoneReferenceType";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Project Plan Phase Milestone Reference Type";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ProjectPlanPhaseMilestoneReferenceTypePicklistMetadata;
